import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  Input,
  ViewChild,
} from "@angular/core";

import { Subscription } from "rxjs";

import {
  AssociationService,
  MinesiteService,
  EquipmentService,
  Equipment,
  MinesiteEquipment,
  Minesite,
  ToastrService,
} from "./../../../../shared/index";
import { ModalDirective } from "ngx-bootstrap/modal";

@Component({
  selector: "minesite-entity",
  templateUrl: "./minesite-entity.html",
  standalone: false,
})
export class MinesiteEntityComponent implements OnInit, OnDestroy {
  @Input("minesite") minesite: Minesite = new Minesite();
  @Input("companyId") companyId = 0;
  @Input("simplified") simplified = false;
  @Input("detail") detail = false;
  @Input("full") full = false;
  @Input("live") live = true;
  // @Input("Is_Project_Selected") Is_Project_Selected: boolean = false;
  // @Input("Is_Published") Is_Published: boolean = false;
  @ViewChild("DeleteMinesite") ModelDeleteMinesite: ModalDirective;
  public equipmentVisible = false;
  public equipment: Equipment[] = [];
  public IsLoading = false;
  public Progress = "";

  private subscriptions: Subscription[] = [];

  label: string;
  textColor: string | string[] | { [klass: string]: boolean } = "";
  ClassName = "";
  constructor(
    private _associationService: AssociationService,
    private _ngZone: NgZone,
    private _minesiteService: MinesiteService,
    private _equipmentService: EquipmentService,
    private _toastrService: ToastrService
  ) {
    this.ClassName = "panel-heading";
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this._equipmentService.minesiteEquipmentChange.subscribe(
        (info: MinesiteEquipment) => {
          if (this.live) {
            if (info.MinesiteId == this.minesite.Id) {
              this._ngZone.run(() => {
                if (info.Reload == true)
                  this.equipment.splice(0, this.equipment.length);
                //this.equipment = info.Equipment;
                info.Equipment.forEach((e) => {
                  this.equipment.push(e);
                });
                this.IsLoading = info.IsLoading;
                this.Progress = info.Progress;
              });
            }
          } else {
            if (info.MinesiteId == this.minesite.Minesite_ID) {
              this._ngZone.run(() => {
                if (info.Reload == true)
                  this.equipment.splice(0, this.equipment.length);
                //this.equipment = info.Equipment;
                info.Equipment.forEach((e) => {
                  this.equipment.push(e);
                });
                this.IsLoading = info.IsLoading;
                this.Progress = info.Progress;
              });
            }
          }
        }
      )
    );
    //this.subscriptions.push(this._globalService.deleteResultEx.subscribe((result: DeleteConfirmation) => {
    //    if (result.EntityType == "minesite" && result.Confirmed && result.EntityId == this.minesite.Minesite_ID) {
    //        this._minesiteService.delete(this.minesite.Minesite_ID);
    //    }
    //}));
    this.label = this.minesite.Name;

    //if (!this.minesite.Live) {
    //    this.textColor = "text-danger";
    //    this.label = "**" + this.minesite.Name + "**";
    //}
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  public getEquipment(): void {
    this.IsLoading = true;
    this.Progress = "";
    //this.Is_Published = true;
    if (this.live) {
      this.equipmentVisible = !this.equipmentVisible;
      if (this.equipmentVisible) {
        this._equipmentService.getEquipmentForMinesite(this.minesite.Id);
      }
    } else {
      this.equipmentVisible = !this.equipmentVisible;
      if (this.equipmentVisible) {
        this._equipmentService.getEquipmentForMinesiteStaging(
          this.minesite.Minesite_ID
        );
      }
    }
  }

  public removeAssociation(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this._minesiteService.removeAssociation(
      this.companyId,
      this.minesite.Minesite_ID
    );
  }
  public delete(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this.ModelDeleteMinesite.show();
    //this._globalService.confirmDelete("minesite", this.minesite.Name, this.minesite.Minesite_ID);
  }

  public edit(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this._minesiteService.edit(this.minesite);
  }

  public details(): void {
    this._minesiteService.showDetails(this.minesite, this.live);
  }

  DeleteSelectedMinesite() {
    this.ModelDeleteMinesite.hide();
    this._minesiteService.delete(this.minesite.Minesite_ID);
  }
  Close(): void {
    this.ModelDeleteMinesite.hide();
  }
  public cdkDropEventTriggered(event: any): void {
    if (event.item.data instanceof Equipment) {
      if (Number(localStorage.getItem("Lock")) === 1) {
        this._toastrService.displayToastrMessage(
          "error",
          localStorage.getItem("Msg"),
          "Environment Status!"
        );
        return;
      }
      this._associationService.associateEquipmentToMinesite(
        this.minesite.Minesite_ID,
        event.item.data.Equipment_ID
      );
    }
  }
}
